import { useState, useEffect, useContext } from 'react'
import { BiX } from 'react-icons/bi'
import { ClientContext } from '../../../contexts/clientProvider'
import { FornecedoresContext } from '../../../contexts/fornecedoresProvider'
import { dadosFornecedores, componentsMap } from '../../General/Format/fornecedores'

const Visualizar = ({ fornecedor, setFornecedor, closeModal }) => {
  const { estados } = useContext(ClientContext);
  const { updateFornecedor } = useContext(FornecedoresContext);
  const [editedData, setEditedData] = useState({});
  const [type, setType] = useState('Geral');
  const [municipios, setMunicipios] = useState([]);

  useEffect(() => {
    setEditedData(fornecedor)
  }, [fornecedor])

  const fetchData = async (estadoNome) => {
    try {
      // Encontrar o ID do estado pelo nome
      const estado = estados.find(e => e.nome === estadoNome);
      if (estado) {
        const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado.id}/municipios`);
        const data = await response.json();
        return data;
      }
      return [];
    } catch (error) {
      console.error('Erro ao recuperar dados:', error);
      return [];
    }
  };

  useEffect(() => {
    if (editedData.estado) {
      fetchData(editedData.estado).then(setMunicipios);
    }
  }, [editedData.estado, estados]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleEditClick = () => {
    setType('Edit');
    setEditedData(fornecedor);
  };

  const handleSaveClick = async () => {
    let fornecedor = { ...editedData }
    fornecedor.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
    let newForn = await updateFornecedor(fornecedor);
    setFornecedor(newForn);
    setType('Geral');
  };

  const handleCancelClick = () => {
    setType('Geral');
  };

  const dados = dadosFornecedores(editedData)
  const components = componentsMap(closeModal, handleCancelClick, handleSaveClick, handleEditClick, handleInputChange)

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4' onClick={(e) => e.target === e.currentTarget && closeModal()}>
      <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col'>
        {/* Header */}
        <div className='flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700'>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Fornecedor {fornecedor.nome}
          </h1>
          <button 
            onClick={() => closeModal()} 
            className='p-2 text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700'
          >
            <BiX className='w-6 h-6' />
          </button>
        </div>

        {/* Content */}
        <div className='flex-1 overflow-auto p-6'>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {dados.map((dado, index) => (
              <div className='space-y-1' key={index}>
                {components[type](dado)}
              </div>
            ))}

            {type === 'Edit' && (
              <>
                <div className='space-y-1'>
                  <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
                    Estado
                  </label>
                  <select 
                    name='estado' 
                    onChange={handleInputChange}
                    value={editedData.estado || ''}
                    className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-vox-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white'
                  >
                    <option value=''>Selecione o estado</option>
                    {estados.map((estado, index) => (
                      <option key={index} value={estado.nome}>
                        {estado.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='space-y-1'>
                  <label className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1'>
                    Cidade
                  </label>
                  <select 
                    name='municipio' 
                    onChange={handleInputChange}
                    value={editedData.municipio || ''}
                    className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-vox-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white'
                  >
                    <option value=''>Selecione a cidade</option>
                    {municipios.map((municipio, index) => (
                      <option key={index} value={municipio.nome}>
                        {municipio.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
          {components[`buttons${type}`]()}
        </div>
      </div>
    </div>
  )
}

export default Visualizar
